const MySpinner = ({ className = "" }) => (
  <div
    className={`${className} primary-color`}
    style={{
      border: "4px solid currentColor",
      borderLeftColor: "transparent",
      borderRadius: "50%",
      width: "24px",
      height: "24px",
      margin: "auto",
      animation: "spin 1s linear infinite",
    }}
  ></div>
);

export default MySpinner;
